import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';

import { firebaseWebConfig } from './config';

/**
 * Web only ever has a single Firebase project, fixed at build time by the
 * `EXPO_PUBLIC_FIREBASE_*` values. The native `development`/`production` toggle
 * (a secondary runtime app) has no web equivalent, so the env-store accessors
 * below resolve to this one app instead of crashing.
 */
export type FirebaseEnv = 'development' | 'production';

export function getFirebaseApp() {
  if (getApps().length === 0) {
    return initializeApp(firebaseWebConfig);
  }
  return getApp();
}

/**
 * Web counterpart of native `ensureProductionFirebaseApp`. There is no separate
 * production app on web (the project is baked in at build time), so this just
 * resolves to the single web app. Kept so `firebase-env-store.triggerProductionInit`
 * doesn't call an `undefined` export (which threw a TypeError on web).
 */
export const ensureProductionFirebaseApp = async (): Promise<FirebaseApp> => getFirebaseApp();

/**
 * Web counterpart of native `getFirebaseAppForEnv`. Native returns a per-env app;
 * web always uses the single build-time app, so the env arg is ignored.
 */
export const getFirebaseAppForEnv = (_env: FirebaseEnv): FirebaseApp => getFirebaseApp();
